import { HospitalityRoomStatus } from '../../constants/roomStatuses'
import type { HotelsTranslationLike } from '../../i18n'
import { translateHotelsText } from '../../i18n'

export const getRoomStatusLabel = (
  status: HospitalityRoomStatus | number | string,
  translator?: HotelsTranslationLike,
): string => {
  const normalizedStatus = Number(status) as HospitalityRoomStatus

  switch (normalizedStatus) {
    case HospitalityRoomStatus.DIRTY:
      return translateHotelsText(
        translator,
        'hotels.dashboard.roomStatusActions.dirty',
        'Dirty',
      )
    case HospitalityRoomStatus.CLEAN:
      return translateHotelsText(
        translator,
        'hotels.dashboard.roomStatusActions.clean',
        'Clean',
      )
    case HospitalityRoomStatus.OCCUPIED:
      return translateHotelsText(
        translator,
        'hotels.dashboard.roomStatusActions.occupied',
        'Occupied',
      )
    case HospitalityRoomStatus.INSPECTED:
      return translateHotelsText(
        translator,
        'hotels.dashboard.roomStatusActions.inspected',
        'Inspected',
      )
    default:
      return ''
  }
}
